import Config from '../../config';
import authEndpoints from './authEndpoints';
import apiClient from '../apiClient';

// interface for the parameters of the getCustomToken function
interface CustomTokenParams {
  Email: string;
  OTPCode: string;
  Purpose: string;
  companyId?: string;
}

export const verifyOTP = async ({
  Email,
  OTPCode,
  Purpose,
  companyId,
}: CustomTokenParams) => {
  const { API_URL } = Config;
  const response = await apiClient.post(
    `${API_URL}${authEndpoints.verifyOTP}`,
    { email: Email, otpCode: OTPCode, purpose: Purpose, CompanyId: companyId },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response;
};
